import React from 'react'
import { validateUsername } from "../validation"
import { ACTION_CHANGE, ACTION_REQUEST } from "./index"
import SpinnerAnimation from '../../../components/Spinner'

const SendVerificationButton = ({username, onRequestAccessLink, asLink = false,
                                again = false, formSubmitted = false}) => (
    <button
        type = { asLink ? "button" : "submit" }
        autoFocus = { username && !again }
        className = { asLink ? "signup-btn send-vcode-btn" : "login-submit" }
        onClick   = { onRequestAccessLink(again) }
        disabled  = { (validateUsername(username) || formSubmitted) ? "disabled" : "" }
        title     = { username !== "" ? "" : "enter username" }
    >
        { again ? "Re-send verification code" : "Send verification code" }
        {/* Only show spinner for primary submit button, not for resend link */}
        {!asLink && <SpinnerAnimation style={{ float: "right", display: formSubmitted ? "" : "none" }}/>}
    </button>
);

// Accommodates verification code request and password change
const ChangePassword = ({
    action,
    formSubmitted,
    resendingCode,
    username,
    accessLinkHasBeenSent,
    skippedToCode,
    onRequestAccessLink,
    onSkipToCode,
    verificationCode,
    oldPassword,
    newPassword,
    validating,
    newPasswordCheck,
    onChange,
    onFocus,
    onSubmit,
    onCancel,
    errors
}) => (
    <div>
        {
            action === ACTION_REQUEST &&
            <p>
                <input
                  className    = "login-control-username"
                  type         = "text"
                  autoComplete = "username"
                  placeholder  = "Email"
                  value        = { username }
                  onChange     = { onChange('username') }
                  onFocus      = { onFocus('username', true) }
                  onBlur       = { onFocus('username', false) }
                  disabled     = { formSubmitted ? "disabled" : ""}
                />
            </p>
        }
        {
            // request rendered as button
            action === ACTION_REQUEST && !accessLinkHasBeenSent &&
            <p style={{ textAlign: "center" }}>
                {(<SendVerificationButton
                    username={username}
                    onRequestAccessLink={onRequestAccessLink}
                    asLink={false}
                    again={accessLinkHasBeenSent}
                    formSubmitted={formSubmitted} />)}
            </p>
        }
        {
            action === ACTION_REQUEST && !accessLinkHasBeenSent && !skippedToCode &&
            <p style={{ textAlign: "center" }}>
                <button
                    type="button"
                    className="signup-btn"
                    onClick={onSkipToCode}
                    disabled={validateUsername(username) ? "disabled" : ""}
                >
                    I already have a reset code
                </button>
            </p>
        }
        { (action === ACTION_CHANGE || (action === ACTION_REQUEST && (accessLinkHasBeenSent || skippedToCode))) &&
            <div>
                {verificationCode == null && action === ACTION_CHANGE && (
                  <p style={{ textAlign: "center", marginBottom: "15px" }} className="text-muted">
                    Enter your current password to set a new password
                  </p>
                )}
                {verificationCode != null && (
                  <input
                    type="hidden"
                    value={verificationCode}
                    onChange={onChange('verificationCode')}
                  />
                )}
                {verificationCode == null && action === ACTION_CHANGE && (
                  <p>
                    <input
                      className="login-control-pass"
                      type='password'
                      autoComplete="off"
                      placeholder='Current Password'
                      value={oldPassword}
                      onChange={onChange('oldPassword')}
                      onBlur={onFocus('oldPassword', false)}
                      disabled={formSubmitted ? "disabled" : ""}
                    />
                  </p>
                )}
                {action === ACTION_REQUEST && accessLinkHasBeenSent && (
                  <p>
                    <input
                      className="login-control-pass"
                      type='text'
                      autoComplete="off"
                      placeholder='Verification Code (from email)'
                      value={verificationCode || ""}
                      onChange={onChange('verificationCode')}
                      onBlur={onFocus('verificationCode', false)}
                      disabled={formSubmitted ? "disabled" : ""}
                    />
                  </p>
                )}
                <p className="password-field-container">
                  <input
                    type         = "password"
                    className    = "login-control-pass"
                    autoComplete = "current-password"
                    placeholder  = "New Password"
                    value        = { newPassword }
                    onChange     = { onChange('newPassword') }
                    onBlur       = { onFocus('newPassword', false) }
                    disabled     = { formSubmitted ? "disabled" : ""}
                  />
                  <SpinnerAnimation className="password-validation-spinner" style={{ display: validating ? "" : "none" }}/>
                </p>
                <p>
                    <input
                        type         = "password"
                        className    = "login-control-pass"
                        autoComplete = "current-password"
                        placeholder  = "Confirm Password"
                        value        = { newPasswordCheck }
                        onChange     = { onChange('newPasswordCheck') }
                        onBlur       = { onFocus('newPasswordCheck', false) }
                        disabled     = { formSubmitted ? "disabled" : ""}
                    />
                </p>
                <p>
                    <button autoFocus
                        className = "login-submit"
                          onClick = { onSubmit }
                        disabled  = { (errors.submit || formSubmitted) ? "disabled" : "" }
                    >
                        Change Password
                      <SpinnerAnimation style={{ float: "right", display: formSubmitted ? "" : "none" }}/>
                    </button>
                </p>
            </div>
        }
        <p className="signup-block">
            <button
                type        = "button"
                className   = "signup-btn"
                onMouseDown = { onCancel }
                disabled    = { formSubmitted ? "disabled" : ""}
            >
                {action === ACTION_CHANGE ? "Cancel" : "Back to sign-in"}
            </button>
            {
                // Re-send verification code button for password reset flow
                ((action === ACTION_CHANGE && verificationCode != null)
                || (action === ACTION_REQUEST && (accessLinkHasBeenSent || skippedToCode)))
                && (<SendVerificationButton
                         username={username}
                         onRequestAccessLink={onRequestAccessLink}
                         asLink={true}
                         again={accessLinkHasBeenSent}
                         formSubmitted={resendingCode || validateUsername(username)} />)
            }
        </p>
    </div>
)

export default ChangePassword;
